import PropTypes from 'prop-types'
import styled from 'styled-components/macro'

import { IconQuestionCircle } from '@loadsmart/icons'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { OfferExpirationBar } from 'legacy/components/OfferExpirationBar/OfferExpirationBar'
import { Tooltip } from 'legacy/components/Tooltip/Tooltip'

const Wrapper = styled.div`
  width: auto;
  background-color: ${getToken('color-neutral-lighter')};
  padding: 5px 10px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
`

const StyledIconQuestionCircle = styled(IconQuestionCircle)`
  width: 15px;
  height: 15px;
  margin: 0 5px;
`

const MainText = styled.span`
  text-transform: uppercase;
  white-space: nowrap;
`

const VerticalSeparator = styled.div`
  border-left: 1px solid ${getToken('color-neutral-light')};
  height: 15px;
  margin: 0 5px;
`

function ExpirationInfo(props) {
  const { isContracted, isLoadCandidate, created_at, expires_at, forceMobile, onExpiration } = props

  return (
    <Wrapper>
      <MainText>
        {isContracted && 'Contracted'}
        {isLoadCandidate && ' ShipperDirect'}
      </MainText>

      {isLoadCandidate && (
        <Tooltip offset={15}>
          <StyledIconQuestionCircle />

          <Tooltip.Bubble width={240}>
            <strong>ShipperDirect</strong> loads need to be approved by the shipper
          </Tooltip.Bubble>
        </Tooltip>
      )}

      <VerticalSeparator />

      <OfferExpirationBar
        created_at={created_at}
        expires_at={expires_at}
        onExpiration={onExpiration}
        forceMobile={forceMobile}
      />
    </Wrapper>
  )
}

ExpirationInfo.propTypes = {
  created_at: PropTypes.instanceOf(Date).isRequired,
  expires_at: PropTypes.instanceOf(Date).isRequired,
  onExpiration: PropTypes.func.isRequired,
  isContracted: PropTypes.bool,
  isLoadCandidate: PropTypes.bool,
  forceMobile: PropTypes.bool,
}

ExpirationInfo.defaultProps = {
  isContracted: false,
  isLoadCandidate: false,
  forceMobile: false,
}

export { ExpirationInfo }
